import React from "react";
import Breadcrumbs from "components/common/Breadcrumbs";
import Text from "components/common/Text";
import CheckInCustomerDetails from "components/CustomerAccount/CheckInCustomerDetails";
import { CheckIncustomerApi } from "stores/CheckIn/CheckInCustomerApi";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Alert, Snackbar } from "@mui/material";

export const withLocation = (Component) => {
  return (props) => {
    const location = useLocation();
    return <Component {...props} location={location} />;
  };
};
class CheckInCustomerDetailsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customerDetails: {},
      navigationdata: {},
      searchhistorydata: {},
      vehiclesdata: {},
      chargingHistorydata: {},
      opendrawer: false,
      visit_id: "",
      user_id: "",
      modalMessage: {
        open: false,
        message: "",
      },
    };
  }
  toggleDrawer = (open) => {
    this.setState({ opendrawer: open });
  };

  handleSnackbarClose = () => {
    this.setState({
      modalMessage: {
        open: false,
      },
    });
  };
  componentDidMount() {
    const { id } = this.props.match.params;
    this.setState({ user_id: this.props.match.params });
    this.setState({ visit_id: this.props.location.visit_id });
    this.props.getCheckinCustomerbyidData(id);
    this.getCustomerDetails();
  }

  handlecheckinsubmit = async (data) => {
    const id = this.state.user_id.id;

    try {
      const res = await CheckIncustomerApi.AddCheckinCostomerApi(data);

      if (res?.status === 1) {
        this.setState({ opendrawer: false });
        this.setState({
          modalMessage: {
            open: true,
            message: res?.message,
          },
        });
        this.props.getCheckinCustomerbyidData(id);
      } else {
        console.error(
          "Form submission failed:",
          res?.message || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error during form submission:", error);
    }
  };
  
  getCustomerDetails = async () => {
    const { id } = this.props.match.params;
    const res = await CheckIncustomerApi.CustomerbyId(id);
    this.setState({
      customerDetails: res.result,
    });
    const result = await CheckIncustomerApi.checkinsearchNavigtionbyId(id);
    this.setState({
      navigationdata: result.result,
    });
    const chargingHistory = await CheckIncustomerApi.checkinChargingHistorybyId(
      id
    );
    this.setState({
      chargingHistorydata: chargingHistory?.data,
    });

    const vehicles = await CheckIncustomerApi.checkinVehiclesbyId(id);
    this.setState({
      vehiclesdata: vehicles.result,
    });
    const searchhistory =
      await CheckIncustomerApi.checkinsearchSearchHistorybyId(id);
    this.setState({
      searchhistorydata: searchhistory.result,
    });
  };

  handlegetcustomerid = () => {
    this.props.getCheckinCustomerbyidData();
  };
  render() {
    const checkincustomertabledata = this.props.getcheckinCustomerbyid?.result;
    const history = this.props.history;

    const props = {
      basicDetail: this.props.basicDetailData,
    };

    const dropdownData = this.props.CheckIncustomerList?.dropdownData;
    return (
      <>
        <Breadcrumbs
          sx={{
            fontSize: "14px",
            marginBottom: "20px",
            marginTop: "10px",
            color: "#a2a2a2",
          }}
        >
          <Text
            onClick={() => history.goBack()}
            sx={{ fontSize: "14px", cursor: "pointer", color: "#a2a2a2" }}
          >
            Check In
          </Text>

          <Text
            sx={{
              fontSize: "14px",
              color: "#a2a2a2",
            }}
            color="text.primary"
          >
            Customer Details
          </Text>
        </Breadcrumbs>

        <CheckInCustomerDetails
          handlecheckinsubmit={this.handlecheckinsubmit}
          toggleDrawer={this.toggleDrawer}
          visit_id={this.state.visit_id}
          opendr={this.state.opendrawer}
          handlegetcustomerid={this.handlegetcustomerid}
          checkincustomertabledata={checkincustomertabledata}
          customerDetails={this.state.customerDetails}
          chekinNavigationData={this.state.navigationdata}
          vehiclesdata={this.state.vehiclesdata}
          searchhistorydata={this.state.searchhistorydata}
          chargingHistory={this.state.chargingHistorydata}
          dropdownData={dropdownData}
        />
        <Snackbar
          open={this.state.modalMessage.open}
          autoHideDuration={3000}
          onClose={this.handleSnackbarClose}
          message={this.state.modalMessage.message}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert severity="success">{this.state.modalMessage.message}</Alert>
        </Snackbar>
      </>
    );
  }
}
export default withLocation(CheckInCustomerDetailsContainer);
